import React, { useState, useEffect } from 'react';
import { GlobalStyle, BoxIn, Goals, Bod, Text, Gator} from './style';


function Mission (){
    return(
        <div>
           <BoxIn>
               <Text>
               We think every body is beautiful, now let's stop being hogzilla for a moment strap our computer on, eat the chili powder
               cleansing detergent detoxification dish soap to anything you eat. You would believe that it is a fast fun healthy
               </Text>
               <Text>
               -Chris Nation CEO
               </Text>
           </BoxIn>
            <Gator style={{marginLeft: '12.5%', color: '#6c757d'}}>MISSION STATEMENT</Gator>
        </div>
    )
}

export default Mission;